import { Video } from '~/types';

export function resolveVideoEmbedComponent(video: Video) {
  switch (video.video_type) {
    case 'wmt_video':
      return 'WmtVideoEmbed';
    case 'youtube':
      return 'YoutubeVideo';
    case 'facebook':
      return 'FacebookVideoEmbed';
    case 'hls':
      return 'HlsEmbed';
    default:
      console.error(`Unable to resolve component for video type ${video.video_type}`);
      return null;
  }
}
